export const UPDATE_FILE_STATE = 'UPDATE_FILE_STATE';
